import { render, staticRenderFns } from "./UserCredits.vue?vue&type=template&id=386532bb&"
import script from "./UserCredits.vue?vue&type=script&lang=js&"
export * from "./UserCredits.vue?vue&type=script&lang=js&"
import style0 from "~/assets/scss/sections/navbar/user-credits.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports